import { Container, Row } from "reactstrap";
import OrgStatusChart from "./stat-charts/OrgStatusChart";
import MobileUserStatsChart from "./stat-charts/MobileUserStatsChart";
import UserStatsChart from "./stat-charts/UserStatsChart";

import OrganizationStats from "./stat-charts/OrganizationStats";
import OrganizationByCountry from "./stat-charts/OrganizationByCountry";
import RadialBarChart from "./stat-charts/RadialBarChart";
import OrganizationAccounts from "./stat-tables/OrganizationAccounts";
import OrganizationPayments from "./stat-tables/OrganizationPayments";

const ContainerDefault = () => {
  return (
    <>
       
       <Container fluid className="responsive-dashboard-grid" style={{ paddingTop: 30 }}>
        <Row className="gx-2 gy-3">
          <OrganizationStats />
        </Row>
        <Row className="gx-2 gy-3">
          <OrgStatusChart />
          <UserStatsChart />
        </Row>
        <Row className="gx-2 gy-3">
          <OrganizationAccounts />
          <RadialBarChart />
        </Row>
        <Row className="gx-2 gy-3">
          <OrganizationPayments />
          <MobileUserStatsChart />
        </Row>
        <Row className="gx-2 gy-3">
          <OrganizationByCountry />
        </Row>
      </Container>
    </>
  );
};

export default ContainerDefault;